<template>
  <div class="overflow-auto bg-n-surface-1 w-full px-4 lg:px-8 py-4">
    <div class="w-full max-w-[1680px] mx-auto pb-12">
      <router-view />
    </div>
  </div>
</template>
